import { render, staticRenderFns } from "./CargoArrivalInquiry.vue?vue&type=template&id=480a0f5d&scoped=true"
import script from "./CargoArrivalInquiry.vue?vue&type=script&lang=js"
export * from "./CargoArrivalInquiry.vue?vue&type=script&lang=js"
import style0 from "./CargoArrivalInquiry.vue?vue&type=style&index=0&id=480a0f5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a0f5d",
  null
  
)

export default component.exports